import { ModuleProps, CreateModuleProps } from "components";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "SETTINGS_PERSONAL_DATA",
    parentId: "SETTINGS_PARENT",
    applicationRights: Rights,
    title: 'Persondata',
    text: 'Persondata',
    icon: 'gear',
    showOnDashboardByDefault: false,
    url: "/settings/PERSONAL_DATA"
})
